import logo from "@/assets/xero-logo.png";

export const XeroLogo = ({ size = 96, className = "" }) => (
  <img
    src={logo}
    width={size}
    height={size}
    className={className}
    alt="Xero logo"
    role="img"
    aria-label="Xero logo"
    data-testid="xero-logo"
    style={{ width: size, height: size, objectFit: "contain" }}
  />
);
